import * as React from 'react';

import {ModalBody} from 'shells/typography/modal-body';

import type {EditionFragment as DripEdition} from 'nutshell-graphql-types';

import {
    SubjectActionBox,
    UnsubscribeActionBox,
    StreetAddressActionBox,
} from '../../../editions/edition-action-boxes';

import styles from './email-drip-edition-preview.module.css';

type Props = {
    selectedEdition: DripEdition;
    streetAddress: string | null | undefined;
    canAccessSetup: boolean;
};

export function EmailDripEditionPreview(props: Props) {
    return (
        <>
            <ModalBody>{props.selectedEdition.name}</ModalBody>
            <div className={styles['details-list']}>
                <SubjectActionBox edition={props.selectedEdition} />
                <UnsubscribeActionBox edition={props.selectedEdition} />
                <StreetAddressActionBox
                    edition={props.selectedEdition}
                    streetAddress={props.streetAddress}
                    canAccessSetup={props.canAccessSetup}
                />
            </div>
        </>
    );
}
